import 'react-tooltip/dist/react-tooltip.css';
import React from 'react';

import Routes from 'routes';
import { GlobalComponentsContextProvider } from 'context/GlobalComponentsContext';
import { GeolocalizeStoreProvider } from 'pages/Geolocalize/store';
import { HeaderFiltersProvider } from 'context/GlobalFiltersContext';
import { AuthContextProvider } from 'context/AuthContext';
import { SocketIoProvider } from 'context/SocketIoContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { CSSReset, CSSGlobal } from 'assets/styled/sheets/generic';
import Amplifique from 'components/Amplifique';
import VersionChecker from 'components/VersionChecker';
import { UpdateProvider } from 'context/UpdateContext';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { OutboxProcessor } from 'components/OutboxProcessor';
import { ToastProvider } from 'context/ToastContext';
import { ChunkErrorBoundary } from 'routes/ChunkErrorBoundary';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// Disponibilizar queryClient globalmente para limpeza de cache
if (typeof window !== 'undefined') {
  (window as any).queryClient = queryClient;
}
const LkpApp = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <ChunkErrorBoundary>
          <QueryClientProvider client={queryClient}>
            <CSSReset />
            <CSSGlobal />
            <UpdateProvider>
              <VersionChecker />
              <AuthContextProvider>
                <ToastProvider>
                  <OutboxProcessor />
                  <GlobalComponentsContextProvider>
                    <HeaderFiltersProvider>
                      <GeolocalizeStoreProvider>
                        <SocketIoProvider>
                          <Routes />
                        </SocketIoProvider>
                      </GeolocalizeStoreProvider>
                      <Amplifique />
                    </HeaderFiltersProvider>
                  </GlobalComponentsContextProvider>
                </ToastProvider>
              </AuthContextProvider>
            </UpdateProvider>
          </QueryClientProvider>
        </ChunkErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
  );
};

export const App = Sentry.withProfiler(LkpApp);
